import React from 'react';
import { useNavigate } from 'react-router-dom';
import InternalSeverErrorImg from 'assets/img/errors/500-internal-server-error.svg';
import ErrorDetailPanel from './ErrorDetailPanel';

const Error500 = () => {
  const navigate = useNavigate();

  return (
    <div className="tw-min-h-screen tw-w-full tw-flex tw-items-center tw-justify-center tw-bg-gradient-to-br tw-from-gray-50 tw-to-gray-100 tw-overflow-y-auto tw-py-8">
      <div className="tw-flex tw-flex-col tw-items-center tw-text-center tw-px-4 tw-w-full tw-max-w-2xl">
        {/* Image */}
        <div className="tw-mb-4 tw-w-full tw-max-w-xs">
          <img src={InternalSeverErrorImg} alt="500 Internal Server Error" className="tw-w-full tw-h-auto tw-object-contain" />
        </div>

        {/* Code */}
        <h1 className="tw-text-5xl tw-font-bold tw-text-red-600 tw-mb-1">500</h1>

        {/* Title */}
        <h2 className="tw-text-2xl tw-font-bold tw-text-gray-800 tw-mb-3">Server Error</h2>

        <p className="tw-text-sm tw-text-gray-600 tw-mb-6 tw-leading-relaxed tw-max-w-md">
          Something went wrong on our end. Try refreshing the page or going back and attempting the action again.
        </p>

        {/* Actions */}
        <div className="tw-flex tw-flex-col tw-gap-2 tw-w-full tw-max-w-xs tw-mb-4">
          <button
            onClick={() => navigate(-1)}
            className="tw-w-full tw-px-6 tw-py-2.5 tw-text-sm tw-bg-blue-600 tw-text-white tw-font-semibold tw-rounded hover:tw-bg-blue-700 tw-transition tw-border-0 tw-cursor-pointer"
          >
            ← Go Back
          </button>
          <a
            href="mailto:portal@pebsteel.com.vn"
            className="tw-w-full tw-px-6 tw-py-2.5 tw-text-sm tw-bg-gray-100 tw-text-gray-700 tw-font-semibold tw-rounded hover:tw-bg-gray-200 tw-transition tw-text-center"
          >
            📧 Contact IT Department
          </a>
        </div>

        {/* Diagnostic panel */}
        <ErrorDetailPanel />
      </div>
    </div>
  );
};

export default Error500;
